import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone } from '@fortawesome/fontawesome-free-solid'

class Contact extends Component {
    render() {
        return (
            <div>
                <div className="my-4 text-center">
                    <h2 className="md:text-6xl text-5xl font-bold drop-shadow-md bg-gradient-to-r from-blue-500 to-blue-800 inline-block text-transparent uppercase bg-clip-text">Kontakt</h2>
                    <p className="text-gray-500 text-center font-bold">Sie brauchen mich? Ich bin für Sie da!</p>
                </div>

                <div className="w-full m-12"></div>

                <div className="flex justify-center content-center">
                    <div className="text-center">
                        <div className="bg-white hover:scale-110 border-2 border-gray-200 rounded-3xl px-5 py-4 drop-shadow-lg mb-8 transition duration-400 ease-in-out mx-2 sm:mx-0">
                            <FontAwesomeIcon icon={faEnvelope} className="inline-block w-8 h-auto mr-5 text-blue-600"/>
                            <a
                                href="mailto:info@us-arbeitsrecht.de"
                                className="text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-500 inline-block text-transparent bg-clip-text"
                            >
                                info@us-arbeitsrecht.de
                            </a>
                        </div>

                        <div className="bg-white hover:scale-110 border-2 border-gray-200 rounded-3xl px-5 py-4 drop-shadow-lg transition duration-400 ease-in-out mx-2 sm:mx-0">
                            <FontAwesomeIcon icon={faPhone} className="inline-block w-8 h-auto mr-5 text-blue-600"/>
                            <a
                                href="mailto:info@ra-schulze.net"
                                className="text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-500 inline-block text-transparent bg-clip-text"
                            >
                                +49 176 55517091
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Contact;